import { motion, AnimatePresence } from "framer-motion";
import { Volume2, VolumeX } from "lucide-react";
import { useAmbientAudio } from "@/context/AudioContext";

export const AmbientToggle = () => {
  const { started, muted, toggleMute } = useAmbientAudio();

  return (
    <AnimatePresence>
      {started && (
        <motion.button
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6 }}
          onClick={toggleMute}
          className="fixed bottom-6 left-6 z-[70] flex items-center gap-3 rounded-full border border-[#C5A059]/25 bg-[#050505]/70 px-4 py-2.5 backdrop-blur-xl transition-colors duration-300 hover:border-[#C5A059]/60"
          data-testid="ambient-toggle"
          title={muted ? "Unmute the ritual" : "Mute the ritual"}
          aria-label={muted ? "Unmute ambient sound" : "Mute ambient sound"}
        >
          {muted ? (
            <VolumeX size={16} strokeWidth={1.5} className="text-white/50" />
          ) : (
            <span className="flex items-end gap-[2px]" aria-hidden="true">
              {[0, 1, 2].map((i) => (
                <motion.span
                  key={i}
                  className="w-[2px] rounded-full bg-[#C5A059]"
                  animate={{ height: [4, 12, 6, 14, 4] }}
                  transition={{ duration: 1.4, repeat: Infinity, delay: i * 0.2, ease: "easeInOut" }}
                />
              ))}
            </span>
          )}
          <span className="text-[0.6rem] font-light uppercase tracking-[0.22em] text-white/50">
            {muted ? "Sound off" : "Ritual"}
          </span>
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default AmbientToggle;
